export var CONSTANTS = /*#__PURE__*/function (CONSTANTS) {
  CONSTANTS["BUTTON"] = "button";
  CONSTANTS["LINK"] = "link";
  CONSTANTS["LTR"] = "ltr";
  return CONSTANTS;
}({});